<!-- <app-header-style-one></app-header-style-one> -->
<!-- <div *ngFor="let x of jobsScrollData" class="marquee">
    <marquee behavior="" direction="">{{x.message}}.</marquee>
</div> -->
<!-- <div class="marquee">
    <marquee behavior="scroll" direction="left" scrollamount="6">
         <strong>Job Updates:</strong>
        <span *ngFor="let x of jobsScrollData; let last = last">{{ x.message }} <span *ngIf="!last"> | </span>
        </span>
    </marquee>
</div> -->


<!-- <app-homeone-main-banner></app-homeone-main-banner> -->
<!-- <app-about-page-one></app-about-page-one> -->

<!-- <div class="page-title-area item-bg1">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li>&nbsp;</li>
            </ul>
            <h2>&nbsp;</h2>
        </div>
    </div>
</div> -->

<header class="header-area p-relative">

    <!-- Navbar -->
    <div class="navbar-area navbar-style-three" [ngClass]="{'sticky': isSticky}">
        <div class="container">
            <nav class="navbar navbar-expand-lg navbar-light bg-light" [class.active]="classApplied"
                style="text-align: center;display: flex;align-items: center;justify-content: center;">
                <a class="navbar-brand" routerLink="/">
                    <img src="assets/img/mepma/logo.svg" alt="logo" style="height:65px;">
                </a>
                <a class="navbar-brand d-none" routerLink="/">
                    <img src="assets/img/mepma/logo.svg" alt="logo" style="height:65px;">
                </a>

                <!-- <span class="navbar-toggler">
                    <li class="nav-item">
                        <a routerLink="/" class="nav-link" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact: true}">
                            <span class="titlealret">
                                Last Date For Applying: <span class="subhead"> 07-10-2025</span>
                            </span>
                        </a>
                    </li>
                </span>
                <button class="navbar-toggler" type="button" (click)="toggleClass()">
                    <span class="burger-menu">
                        <span class="top-bar"></span>
                        <span class="middle-bar"></span>
                        <span class="bottom-bar"></span>
                    </span>
                </button> -->
                <!-- <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav">

                        <li class="nav-item" *ngIf="userData==null">
                            <a class="nav-link" routerLinkActive="active" routerLink="/registration">
                                <span class="titlealret">
                                    New Registration
                                </span>
                            </a>
                        </li>
                        <li class="nav-item" *ngIf="userData==null">
                            <a class="nav-link" routerLinkActive="active" (click)="openPopupview(popupname,1,0)">
                                <span class="titlealret">
                                    Login
                                </span>
                            </a>
                        </li>
                        <li class="nav-item" *ngIf="userData!=null">
                            <a class="nav-link" routerLinkActive="active" (click)="navigteApplyForm()">
                                <span class="titlealret">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                        width="24px">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round">
                                        </g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path opacity="0.4"
                                                d="M12.1207 12.78C12.0507 12.77 11.9607 12.77 11.8807 12.78C10.1207 12.72 8.7207 11.28 8.7207 9.50998C8.7207 7.69998 10.1807 6.22998 12.0007 6.22998C13.8107 6.22998 15.2807 7.69998 15.2807 9.50998C15.2707 11.28 13.8807 12.72 12.1207 12.78Z"
                                                stroke="#fff" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                            <path opacity="0.34"
                                                d="M18.7398 19.3801C16.9598 21.0101 14.5998 22.0001 11.9998 22.0001C9.39977 22.0001 7.03977 21.0101 5.25977 19.3801C5.35977 18.4401 5.95977 17.5201 7.02977 16.8001C9.76977 14.9801 14.2498 14.9801 16.9698 16.8001C18.0398 17.5201 18.6398 18.4401 18.7398 19.3801Z"
                                                stroke="#fff" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                            <path
                                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                                stroke="#fff" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                        </g>
                                    </svg> Profile
                                </span>
                            </a>
                        </li>
                        <li class="nav-item" *ngIf="userData!=null">
                            <a class="nav-link" routerLinkActive="active" (click)="logout()">
                                <span class="titlealret">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                        width="24px">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round">
                                        </g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path
                                                d="M13 2C10.2386 2 8 4.23858 8 7C8 7.55228 8.44772 8 9 8C9.55228 8 10 7.55228 10 7C10 5.34315 11.3431 4 13 4H17C18.6569 4 20 5.34315 20 7V17C20 18.6569 18.6569 20 17 20H13C11.3431 20 10 18.6569 10 17C10 16.4477 9.55228 16 9 16C8.44772 16 8 16.4477 8 17C8 19.7614 10.2386 22 13 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2H13Z"
                                                fill="#fff"></path>
                                            <path
                                                d="M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H11.2821C11.1931 13.1098 11.1078 13.2163 11.0271 13.318C10.7816 13.6277 10.5738 13.8996 10.427 14.0945C10.3536 14.1921 10.2952 14.2705 10.255 14.3251L10.2084 14.3884L10.1959 14.4055L10.1915 14.4115C10.1914 14.4116 10.191 14.4122 11 15L10.1915 14.4115C9.86687 14.8583 9.96541 15.4844 10.4122 15.809C10.859 16.1336 11.4843 16.0346 11.809 15.5879L11.8118 15.584L11.822 15.57L11.8638 15.5132C11.9007 15.4632 11.9553 15.3897 12.0247 15.2975C12.1637 15.113 12.3612 14.8546 12.5942 14.5606C13.0655 13.9663 13.6623 13.2519 14.2071 12.7071L14.9142 12L14.2071 11.2929C13.6623 10.7481 13.0655 10.0337 12.5942 9.43937C12.3612 9.14542 12.1637 8.88702 12.0247 8.7025C11.9553 8.61033 11.9007 8.53682 11.8638 8.48679L11.822 8.43002L11.8118 8.41602L11.8095 8.41281C11.4848 7.96606 10.859 7.86637 10.4122 8.19098C9.96541 8.51561 9.86636 9.14098 10.191 9.58778L11 9C10.191 9.58778 10.1909 9.58773 10.191 9.58778L10.1925 9.58985L10.1959 9.59454L10.2084 9.61162L10.255 9.67492C10.2952 9.72946 10.3536 9.80795 10.427 9.90549C10.5738 10.1004 10.7816 10.3723 11.0271 10.682C11.1078 10.7837 11.1931 10.8902 11.2821 11H3Z"
                                                fill="#fff"></path>
                                        </g>
                                    </svg> Logout
                                </span>
                            </a>
                        </li>
                    </ul>
                </div> -->

            </nav>
        </div>
    </div>

</header>


<div class="page-title-area" style="padding-top: 8px;padding-bottom: 8px;background: #ba4d13;">
    <div class="container">
        <div class="page-title-content">
            <ul style="margin-bottom: 0px;">
                <li><a routerLink="/" style="text-decoration: none;font-size: 16px;">Home</a></li>
                <li style="text-decoration: none;font-size: 16px;">Profile</li>
            </ul>
            <!-- <h2 style="font-size: 30px;">About Us</h2> -->
        </div>
    </div>
</div>

<br>
<div class="container">
    <br>

    <ul class="nav-tabset">
        <li class="nav-tab" [ngClass]="{'active': currentTab === 'tab1'}">
            <span class="active" (click)="switchTab($event, 'tab1')">Profile</span>
        </li>
        <li class="nav-tab" [ngClass]="{'active': currentTab === 'tab2'}">
            <span (click)="switchTab($event, 'tab2')">Applied Applications</span>
        </li>

    </ul>
    <div class="tabs-container">
        <div class="pane" id="tab1" *ngIf="currentTab === 'tab1'">
            <mat-card class="cardWithShadow theme-card">
                <h3 style="text-align: center;padding: 18px;">Candidate Details</h3>
                <mat-card-content class="b-t-1">
                    <form [formGroup]="registrationform" #formContainer>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="custom-mat-input-wrapper" style="text-align: center;">
                                    <!-- <label>Upload Picture<span style="color: red;">*</span></label> -->
                                    <input type="file" accept="image/*" #fileInput (change)="onImageChange($event)"
                                        hidden>
                                    <!-- Clickable image that triggers file input -->
                                    <img [src]=" photoPreview ? photoPreview :'assets/img/mepma/profile.png'"
                                        alt="Upload" (click)="fileInput.click()" style="width: 100px; height: 100px; cursor: pointer; border: 2px dashed #ccc;
                                border-radius: 10px; padding: 10px;margin-bottom: 10px;" /><br>
                                    <!-- <span> <strong>Upload Picture<span style="color: red;">*</span></strong> </span> -->
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <label> <strong>Are you SHG/SHG Family Member <span
                                            style="color: red;">*</span></strong></label><br>
                                <div style="display: flex;gap: 18px;margin-top: 16px;">
                                    <label><input type="radio" formControlName="are_you_shg" value="Yes" disabled> SHG
                                        Member</label>
                                    <label><input type="radio" formControlName="are_you_shg" value="No" disabled> SHG
                                        Family
                                        Member</label>
                                </div>

                                <div *ngIf="submittedregist && regist.are_you_shg.errors">
                                    <div *ngIf="regist.are_you_shg.errors" class="errormessage"> Please select Are you
                                        SHG/SHG
                                        Family Member.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-lg-3" style="margin-bottom: 18px;">
                                <label for="">Select District <span style="color: red;">*</span></label>
                                <ng-select placeholder="Select District" formControlName="district_id"
                                    [readonly]="'true'">
                                    <ng-option value="" selected disabled>Select District</ng-option>
                                    @for (d of districtData; track d.district_id) {
                                    <ng-option [value]="d.district_id">{{ d.district_name }}</ng-option>
                                    }
                                </ng-select>
                                <div *ngIf="submittedregist && regist.district_id.errors">
                                    <div *ngIf="regist.district_id.errors" class="errormessage"> Please Select District.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" style="margin-bottom: 18px;">
                                <label for="">Select ULB<span style="color: red;">*</span> </label>
                                <ng-select placeholder="Select ULB" formControlName="ulb_id" [readonly]="'true'">
                                    <ng-option value="" selected disabled>Select ULB</ng-option>
                                    <ng-option [value]="u.ulb_id" *ngFor="let u of ulbData">{{u.ulb_name}}</ng-option>
                                </ng-select>
                                <div *ngIf="submittedregist && regist.ulb_id.errors">
                                    <div *ngIf="regist.ulb_id.errors" class="errormessage"> Please Select ULB.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" style="margin-bottom: 18px;">
                                <label for="">Select SLF<span style="color: red;">*</span></label>
                                <ng-select placeholder="Select SLF" formControlName="slf_id" [readonly]="'true'">
                                    <ng-option value="" selected disabled>Select SLF</ng-option>
                                    <ng-option [value]="s.slf_id" *ngFor="let s of slfData">{{s.slf_name}} -
                                        ({{s.slf_id}})</ng-option>
                                </ng-select>
                                <div *ngIf="submittedregist && regist.slf_id.errors">
                                    <div *ngIf="regist.slf_id.errors" class="errormessage"> Please Select SLF.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" style="margin-bottom: 18px;">
                                <label for="">Select SHG Group<span style="color: red;">*</span></label>
                                <ng-select placeholder="Select SHG Group" formControlName="shg_id" [readonly]="'true'">
                                    <ng-option value="" selected disabled>Select SHG Group</ng-option>
                                    <ng-option [value]="s.shg_group_id"
                                        *ngFor="let s of shgGropsReport">{{s.shg_group_name}} -
                                        ({{s.shg_group_id}})</ng-option>
                                </ng-select>
                                <div *ngIf="submittedregist && regist.shg_id.errors">
                                    <div *ngIf="regist.shg_id.errors" class="errormessage"> Please Select SHG Group.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" style="margin-bottom: 18px;">
                                <label for="">Select Member Id<span style="color: red;">*</span></label>
                                <ng-select placeholder="Select Member Id" formControlName="member_id"
                                    [readonly]="'true'">
                                    <ng-option value="" selected disabled>Select Member Id</ng-option>
                                    <ng-option [value]="s.member_id"
                                        *ngFor="let s of shgmembersReport">{{s.member_name}} -
                                        ({{s.member_id}})</ng-option>
                                </ng-select>
                                <div *ngIf="submittedregist && regist.member_id.errors">
                                    <div *ngIf="regist.member_id.errors" class="errormessage"> Please Select Member Id.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" style="margin-bottom: 18px;"
                                *ngIf="registrationform.get('are_you_shg').value == 'No'">
                                <label for="">Relation with SHG <span style="color: red;">*</span></label>
                                <ng-select placeholder="Relation with SHG " formControlName="relation_with_shg"
                                    [readonly]="'true'">
                                    <ng-option value="" selected disabled>Relation with SHG </ng-option>
                                    <ng-option [value]="s.name" *ngFor="let s of relationships">{{s.name}}</ng-option>
                                </ng-select>
                                <div *ngIf="submittedregist && regist.relation_with_shg.errors">
                                    <div *ngIf="regist.relation_with_shg.errors" class="errormessage"> Please select
                                        Relation
                                        with SHG.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h5>Personal Information</h5>
                        <div class="row">
                            <div class="col-lg-3">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="full_name" appTrimLeadingSpace readonly>
                                    <label>Full Name<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.full_name.errors">
                                    <div *ngIf="regist.full_name.errors" class="errormessage"> Please Enter Full Name.
                                    </div>
                                </div>
                            </div>

                            <!-- Father's / Husband's Name -->
                            <div class="col-lg-3">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="father_or_husband_name" appTrimLeadingSpace readonly>
                                    <label>Father’s / Husband’s Name <span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.father_or_husband_name.errors">
                                    <div *ngIf="regist.father_or_husband_name.errors" class="errormessage"> Please Enter
                                        Father’s / Husband’s Name.
                                    </div>
                                </div>
                            </div>

                            <!-- Date of Birth -->
                            <div class="col-lg-3">
                                <div class="custom-mat-input-wrapper">
                                    <input type="date" class="custom-mat-input" placeholder=" "
                                        formControlName="date_of_birth" [max]="currentdate" readonly>
                                    <label>Date of Birth<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.date_of_birth.errors">
                                    <div *ngIf="regist.date_of_birth.errors" class="errormessage"> Please Enter Date of
                                        Birth.
                                    </div>
                                </div>
                            </div>

                            <!-- Gender -->
                            <div class="col-lg-3">
                                <label>Gender<span style="color: red;">*</span></label>
                                <div style="display: flex;gap: 18px;">
                                    <label><input type="radio" formControlName="gender" value="Male" disabled="">
                                        Male</label>
                                    <label><input type="radio" formControlName="gender" value="Female" disabled="">
                                        Female</label>
                                    <label><input type="radio" formControlName="gender" value="Other" disabled="">
                                        Other</label>
                                </div>
                                <div *ngIf="submittedregist && regist.gender.errors">
                                    <div *ngIf="regist.gender.errors" class="errormessage"> Please select gender.
                                    </div>
                                </div>
                            </div>

                            <!-- Contact Number -->
                            <div class="col-lg-3">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="contact_number" maxlength="10"
                                        (input)="newnumaricprevent($event)" appTrimLeadingSpace readonly>
                                    <label>Contact Number<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.contact_number.errors">
                                    <div *ngIf="regist.contact_number.errors" class="errormessage"> Please Enter Contact
                                        Number.
                                    </div>
                                </div>
                            </div>

                            <!-- Email ID -->
                            <div class="col-lg-3">
                                <div class="custom-mat-input-wrapper">
                                    <input type="email" class="custom-mat-input" placeholder=" " formControlName="email"
                                        appTrimLeadingSpace readonly>
                                    <label>Email ID<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.email.errors">
                                    <div *ngIf="regist.email.errors" class="errormessage"> Please Enter Email ID.
                                    </div>
                                </div>
                            </div>

                            <!-- Aadhaar Number -->
                            <div class="col-lg-3">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="aadhaar_number" maxlength="12"
                                        (input)="newnumaricprevent($event)" appTrimLeadingSpace readonly>
                                    <label>Aadhaar Number<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.aadhaar_number.errors">
                                    <div *ngIf="regist.aadhaar_number.errors" class="errormessage"> Please Enter Aadhaar
                                        Number.
                                    </div>
                                </div>
                            </div>

                            <!-- Address -->
                            <div class="col-lg-3">
                                <!-- <div class="custom-mat-input-wrapper"> -->

                                <textarea class="custom-mat-input" rows="1" placeholder="Address*"
                                    formControlName="address" appTrimLeadingSpace style="margin-top: 16px;"
                                    readonly></textarea>
                                <!-- <label>Address<span style="color: red;">*</span></label> -->
                                <!-- </div> -->
                                <div *ngIf="submittedregist && regist.address.errors">
                                    <div *ngIf="regist.address.errors" class="errormessage"> Please Enter Address.
                                    </div>
                                </div>
                            </div>

                        </div>

                        <hr>

                        <!-- Educational Qualification -->
                        <h5>Educational Qualification</h5>
                        <div class="row">
                            <div class="col-lg-4">
                                <!-- <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" "
                                formControlName="highest_qualification">
                            <label>Highest Qualification<span style="color: red;">*</span></label>
                        </div> -->
                                <!-- <label for="">Highest Qualification<span style="color: red;">*</span></label> -->
                                <ng-select placeholder="Highest Qualification" formControlName="highest_qualification"
                                    style="margin-top: 16px;" [readonly]="'true'">
                                    <ng-option value="" selected disabled>Highest Qualification</ng-option>
                                    <ng-option [value]="s.value"
                                        *ngFor="let s of qualifications">{{s.label}}</ng-option>
                                </ng-select>
                                <div *ngIf="submittedregist && regist.highest_qualification.errors">
                                    <div *ngIf="regist.highest_qualification.errors" class="errormessage"> Please select
                                        qualification.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="year_of_passing" appTrimLeadingSpace readonly>
                                    <label>Year of Passing<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.year_of_passing.errors">
                                    <div *ngIf="regist.year_of_passing.errors" class="errormessage"> Please Enter Year
                                        of
                                        Passing.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="university_or_board" appTrimLeadingSpace readonly>
                                    <label>University / Board<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.university_or_board.errors">
                                    <div *ngIf="regist.university_or_board.errors" class="errormessage"> Please Enter
                                        University
                                        / Board.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <!-- Employment Details -->
                        <h5>Employment Details</h5>
                        <div class="row">
                            <div class="col-lg-3">
                                <label>Currently Employed<span style="color: red;">*</span></label>
                                <div style="display: flex;gap: 18px;">
                                    <label><input type="radio" formControlName="currently_employed" value="Yes"
                                            disabled>
                                        Yes</label>
                                    <label><input type="radio" formControlName="currently_employed" value="No" disabled>
                                        No</label>
                                </div>
                                <div *ngIf="submittedregist && regist.currently_employed.errors">
                                    <div *ngIf="regist.currently_employed.errors" class="errormessage"> Please Select
                                        Currently
                                        Employed.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" *ngIf="registrationform.get('currently_employed').value == 'Yes'">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="work_company_name" appTrimLeadingSpace readonly>
                                    <label>Company Name<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.work_company_name.errors">
                                    <div *ngIf="regist.work_company_name.errors" class="errormessage"> Please Enter
                                        Company
                                        Name.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" *ngIf="registrationform.get('currently_employed').value == 'Yes'">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="designation" appTrimLeadingSpace readonly>
                                    <label>Designation<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.designation.errors">
                                    <div *ngIf="regist.designation.errors" class="errormessage"> Please Enter
                                        Designation.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3" *ngIf="registrationform.get('currently_employed').value == 'Yes'">
                                <div class="custom-mat-input-wrapper">
                                    <input type="text" class="custom-mat-input" placeholder=" "
                                        formControlName="work_experience" readonly>
                                    <label>Work Experience (Years)<span style="color: red;">*</span></label>
                                </div>
                                <div *ngIf="submittedregist && regist.work_experience.errors">
                                    <div *ngIf="regist.work_experience.errors" class="errormessage"> Please Enter Work
                                        Experience (Years).
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-12" style="text-align: center;margin-top: 18px;">
                                <button class="reg-btn" type="button" (click)="logout()"> Logout </button>
                            </div>
                        </div> -->

                    </form>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="pane" id="tab2" *ngIf="currentTab === 'tab2'">
            <section class="testimonial-outer padding-lg">
                <div class="tabs-container">
                    <div class="pane" id="tab1">
                        <div class="col-lg-12 col-md-12">
                            <div class="courses-details-desc">

                                <div style=" overflow: auto;">
                                    <div class="row">
                                        <ul class="nav-tabset">
                                            <li class="nav-tab">

                                                <div class="searchBar">
                                                    <input id="searchQueryInput" type="text" name="searchQueryInput"
                                                        placeholder="Search" [(ngModel)]="serch" autocomplete="off"
                                                        (keyup)="applyFilter($event)" />
                                                    <button id="searchQuerySubmit" type="submit"
                                                        name="searchQuerySubmit">
                                                        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                                                            <path fill="#fff"
                                                                d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />
                                                        </svg>
                                                    </button>
                                                </div>


                                            </li>
                                            <!-- <li class="nav-tab">
                                            <div style="margin-bottom: 18px;">
                                                <ng-select placeholder="Select District">
                                                    <ng-option value="" selected disabled>Select District</ng-option>
                                                    <ng-option [value]="d.district_id"
                                                        *ngFor="let d of districtData">{{d.district_name}}</ng-option>
                                                </ng-select>
                                            </div>
                                        </li> -->

                                            <li class="nav-tab" style="float: right;">
                                                <mat-paginator [pageSizeOptions]="[25,50,100]"
                                                    showFirstLastButton></mat-paginator>
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        <table id="table-to-copied" #tab mat-table [dataSource]="dataSource" matSort
                                            multiTemplateDataRows>
                                            <ng-container matColumnDef="i">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass"> S.No
                                                </th>
                                                <td mat-cell *matCellDef="let row;let j = index" class="centre">
                                                    <span class="para"> {{row.i}} </span>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="district_name">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass">
                                                    District Name
                                                </th>
                                                <td mat-cell *matCellDef="let row"
                                                    style="white-space: nowrap;text-align: left;">

                                                    <span class="para" style="text-align: left;"> {{row.district_name}}
                                                    </span>

                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="mela_date">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass">
                                                    Date
                                                </th>
                                                <td mat-cell *matCellDef="let row">
                                                    <span class="para">
                                                        {{row.mela_date | date:'dd-MM-yyyy'}} </span>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="mela_name">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass">
                                                    Jobmela
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                    <span class="para"> {{row.mela_name}} </span>

                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="qualification">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass">
                                                    Qualification
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                    <span class="para"> {{row.qualification}} </span>

                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="age_limit">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass">
                                                    Age Limit
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                    <span class="para">
                                                        {{row.age_limit? row.age_limit:'---'}}</span>

                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="payment_date">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass">
                                                    Payment Date
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                    <span class="para"> {{row.payment_date | date:'dd-MM-yyyy'}} </span>

                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="payment_status">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass">
                                                    Payment Status
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                    <span class="para"> {{row.payment_status}}
                                                    </span>

                                                </td>
                                            </ng-container>


                                            <ng-container matColumnDef="action">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    [ngStyle]="headerclass" style="width: 120px;">
                                                    Admit Card
                                                </th>
                                                <td mat-cell *matCellDef="let row" (click)="gotoviewDetails(row)">
                                                    <span class="para" style="cursor: pointer;"><strong>Download
                                                        </strong></span>

                                                </td>
                                            </ng-container>
                                            <!-- Footer start -->
                                            <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                                                class="example-element-row clickable-row">
                                            </tr>
                                            <tr class="mat-row" *matNoDataRow>
                                                <td class="mat-cell" colspan="7" style="color: red;">No data found</td>
                                            </tr>
                                            <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                                            class="example-detail-row"></tr> -->
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>












</div>


<div *ngIf="showloader" class="overlap">
    <div class="loader"></div>
</div>